import {
  floatVF,
  integerVF,
  isna,
  moneyVF,
  percentageVF,
} from "../../components/AgTable/gridOptions";

export function formatValue(value: any, columnType: string): string {
  const vf = FORMATTERS_BY_TYPE[columnType];
  return vf(value);
}

const FORMATTERS_BY_TYPE = {
  moneyColumn: (value) => moneyVF({ value }),
  integerColumn: (value) => integerVF({ value }),
  floatColumn: (value) => (isna(value) ? "" : floatVF({ value })),
  percentageColumn: (value) => percentageVF({ value }),
  textColumn: (value) => value,
  categoryColumn: (value) => value,
};
